export enum ModulePlaceableObjectSound {
  OPENED = 1,
  CLOSED = 2,
  DESTROYED = 3,
  USED = 4,
  LOCKED = 5
}